import React from 'react';
import Add from '@mui/icons-material/Add';

import { Button } from 'uikit/buttons';

import InitiativeChips from './initiativeChips';

import styles from '../styles/formFieldInitiativeChips.module.scss';

const FormFieldInitiativeChips = ({
  addButtonText,
  emptyText,
  onAddButtonClick,
  onChipClick,
  chips,
}) => (
  <div className={styles.container}>
    <div className={styles.element}>
      <InitiativeChips chips={chips} emptyText={emptyText} onChipClick={onChipClick} />
      <Button
        className={styles.button}
        icon={<Add />}
        onClick={onAddButtonClick}
        size="small"
        text={addButtonText}
        variant="outlined"
      />
    </div>
  </div>
);

export default React.memo(FormFieldInitiativeChips);
